import * as React from 'react';
import { ErrorMessage, Field, FieldProps } from 'formik';

import { stringToUrl } from '@common/typescript/Utils';

import '@common/react/scss/components/inputBlock.scss';

interface Props {
	fieldName?: string;
	title?: string;
	fromField: string;
	containerClassName?: string;
	additionalSegment?: string;
	additionalSegmentSeparator?: string;
	saveHyphen?: boolean;
	disabled?: boolean;
	refreshBtnTitle?: string;
	withEye?: boolean;
	eyeBtnTitle?: string;
	eyeLink?: string;
	eyeDisabled?: boolean;
	refreshDisabled?: boolean;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onRefresh?: (res: string) => void;
}

const ErrorComponent: React.FC<{error: string | object}> = ({ error }) =>
	<div className="validation-message">
		{typeof error === 'string' ? error : Object.keys(error)
			.filter((key) => typeof error[key] === 'string')
			.map((key) => error[key])
			.join(', ')}
	</div>;

const PathInput: React.FC<Props> = ({
	fieldName = 'path',
	title = 'Path*',
	fromField,
	containerClassName = 'form-group col-sm-6',
	additionalSegment,
	additionalSegmentSeparator = '/',
	saveHyphen,
	disabled,
	refreshBtnTitle,
	withEye,
	eyeBtnTitle,
	eyeLink,
	eyeDisabled,
	refreshDisabled,
	onChange,
	onRefresh,
}) => {
	return <Field name={fieldName}>
		{({ field, form }: FieldProps) =>
			<div className={containerClassName}>
				{title && <label htmlFor={field.name}>{title}</label>}
				<div className="input-block">
					<div className="input-block-field">
						{form.submitCount > 0 && <ErrorMessage name={field.name} render={(msg) => <ErrorComponent error={msg} />} />}
						<input
							className="form-control"
							type="text"
							{...field}
							id={field.name}
							disabled={disabled}
							onChange={onChange || ((e) => form.setFieldValue(fieldName, stringToUrl(e.currentTarget.value, saveHyphen)))}
						/>
					</div>
					{withEye
						? <div className="input-block-btn">
							<a
								href={eyeLink}
								className={`btn btn-sm btn-primary ${eyeDisabled ? 'disabled-with-title' : ''}`}
								title={eyeBtnTitle || 'View'}
								target="_blank"
								rel="noreferrer"
							>
								<i className="fa fa-eye" aria-hidden="true" />
							</a>
						</div>
						: <span className="input-block-btn">
							<button
								type="button"
								title={refreshBtnTitle || 'Refresh'}
								className="btn btn-default btn-sm"
								onClick={() => {
									const res = `${additionalSegment
										? `${additionalSegment}${additionalSegmentSeparator}${stringToUrl(form.values[fromField] || '', saveHyphen)}`
										: stringToUrl(form.values[fromField] || '', saveHyphen)}`;

									form.setFieldValue(fieldName, res);
									onRefresh && onRefresh(res);
								}}
								disabled={refreshDisabled}
							>
								<i className="fa fa-refresh" />
							</button>
						</span>
					}
				</div>
			</div>
		}
	</Field>;
};

export default PathInput;
